import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
	selector: 'reach-menu',
	templateUrl: './menu.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	host: {
		class: 'flex flex-col items-start justify-start',
	},
})
export class ReachSmallMenuComponent {
	@Input() widthSmallMenu = false;
}
